import React from 'react'
import './travel.css'

const Travel = () => {
  return (
    <div>
      <div className="travel-page-container">
        <h1 className="m-fancy-text">Travel</h1>
        <h2>By Air</h2>
        <p className="airports">
          Château de Lisse is around a 1.5 hour drive from three airports in
          Bordeaux, Toulouse and Bergerac.
        </p>
        <h2>By Train</h2>
        <p className="train-stations">
          The nearest train station is Agen (45 min drive) which has services
          running from Paris, Bordeaux, and Toulouse.
        </p>
      </div>
    </div>
  )
}
export default Travel



// WEBPACK FOOTER //
// ./src/components/Travel/Travel.js